import useDelegateUsers from "backend/hooks/workflows/useDelegateUsers";
import useSubmitDelegateTask from "backend/hooks/workflows/useSubmitDelegateTask";
import { ICardElementWithChildren } from "backend/model/model";
import DelegateModal from "design/components/popups/DelegateModal";
import { t } from "i18next";
import React from "react";
const DelegateModalPopup = (props: {
  elem?: ICardElementWithChildren;
  onClose: () => void;
  isOpen?: boolean;
}) => {
  const { data: delegateUsers, isLoading: isLoadingDelegateUsers } =
    useDelegateUsers(props.elem?.workflowState?.wfInstanceId || "");

  const { mutate } = useSubmitDelegateTask();
  return (
    <DelegateModal
      users={delegateUsers || []}
      open={!!props.isOpen}
      onClose={props.onClose}
      onSubmit={(values) => {
        const userId = values.find((v) => v.field.fieldName === "user")?.value;
        const message = values.find(
          (v) => v.field.fieldName === "message"
        )?.value;

        if (typeof userId === "string" && typeof message === "string") {
          mutate({
            wfInstanceId: props.elem?.workflowState?.wfInstanceId || "",
            userId,
            message,
          });
          props.onClose();
        }
      }}
      title={t("mytasks.Delegate")}
      buttonText={t("mytasks.Delegate")}
      fields={[
        {
          type: "info",
          title: props.elem?.typename || "",
          content: (
            <div>
              {props.elem?.name} ({props.elem?.workflowState?.period || ""})
            </div>
          ),
        },
        {
          title: t("mytasks.Users"),
          type: "select",
          fieldName: "user",
          values:
            delegateUsers?.map((usr) => ({
              id: usr.userId,
              title: usr.fullname,
            })) || [],
        },
        {
          title: t("mytasks.Message"),
          type: "textarea",
          fieldName: "message",
        },
      ]}
    ></DelegateModal>
  );
};

export default DelegateModalPopup;
